export default __webpack_public_path__ + "static/media/blueActiveSvg.5b7f66e0.svg";